import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useAuthStore = create(
  persist(
    (set) => ({
      token: null,
      user: null,
      orgId: null,
      orgSlug: null,
      setSession: ({ token, user }) => set({
        token,
        user,
        orgId: user?.org_id || null,
        orgSlug: user?.org_slug || null,
      }),
      setOrg: (orgId, orgSlug) => set({ orgId, orgSlug }),
      clear: () => set({ token: null, user: null, orgId: null, orgSlug: null }),
    }),
    { name: 'redserp-auth' }
  )
);
